enum ContactStatus {
  Active = "ACTIVE",
  Deleted = "DELETED",
}

export default ContactStatus;
